import FormCheckbox from '@/components/molecules/FormCheckbox';
import { SearchFilterGeneralProps } from '@/components/organisms/SearchFilterGeneralInfoSection/SearchFilterGeneralInfoSection';

export const SearchFilterEVScoreSection: React.FC<SearchFilterGeneralProps> = ({
  filters,
  updateFilter,
}) => {
  const handleChange = (evt: boolean, value: string) => {
    let evScoreArray = filters.ev_score;
    if (evt) {
      evScoreArray.push(value);
    } else {
      evScoreArray = evScoreArray.filter((evScore) => evScore !== value);
    }
    updateFilter({
      fields: {
        ev_score: evScoreArray,
      },
    });
  };

  const evScoreList = ['Excellent', 'Good', 'Average', 'Limited'];
  return (
    <section className="flex flex-col gap-s pt-s">
      <div className="text-microLight text-neutral-800">Estimated capacity</div>
      {evScoreList.map((item) => (
        <FormCheckbox
          key={item}
          className="flex w-full items-center justify-start rounded-small bg-neutral-100 px-l py-m hover:bg-neutral-200"
          checkBoxStyle="size-[20px] border-[1px] rounded-xsmall"
          onChange={(evt) => handleChange(evt, item)}
          checked={filters.ev_score.includes(item)}
          checkboxLabel={item}
        />
      ))}
    </section>
  );
};
